import { Check } from "lucide-react";
import { usePub, useHead } from "./PublicSite";
import { PricingBlock } from "./Landing";

export const Features = () => {
  const { pt } = usePub();
  useHead(pt("meta.features_title"), pt("meta.features_desc"));
  return (
    <div className="pub-section" data-testid="features-page">
      <div className="pub-wrap">
        <h1 className="pub-h1 pub-h1-sm">{pt("features.title")}</h1>
        <p className="pub-lead">{pt("features.sub")}</p>
        <div className="pub-feature-rows">{[1, 2, 3, 4, 5, 6].map((i) => (
          <section key={i} className="pub-feature-row" data-testid={`features-section-${i}`}>
            <span className="pub-step-n font-mono">0{i}</span>
            <div><h2 className="pub-h3">{pt(`features.s${i}_t`)}</h2><p>{pt(`features.s${i}_b`)}</p></div>
            <ul>{[1, 2, 3].map((j) => <li key={j}><Check className="h-4 w-4 shrink-0" /><span>{pt(`features.s${i}_p${j}`)}</span></li>)}</ul>
          </section>
        ))}</div>
      </div>
    </div>
  );
};

export const Pricing = () => {
  const { pt } = usePub();
  useHead(pt("meta.pricing_title"), pt("meta.pricing_desc"));
  return (
    <div className="pub-section" data-testid="pricing-page">
      <div className="pub-wrap">
        <h1 className="pub-h1 pub-h1-sm text-center" data-sticky-anchor>{pt("pricing.title")}</h1>
        <p className="pub-lead text-center mx-auto">{pt("pricing.sub")}</p>
        <PricingBlock />
        <p className="pub-muted text-center mt-4" data-testid="pricing-vat">{pt("pricing.vat")}</p>
        <div className="pub-info-grid">{["credits", "topup", "addon"].map((k) => (
          <div key={k} className="pub-info" data-testid={`pricing-info-${k}`}><h2 className="pub-h3">{pt(`pricing.${k}_t`)}</h2><p>{pt(`pricing.${k}_b`)}</p></div>
        ))}</div>
      </div>
    </div>
  );
};
